

// import React from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import Slider from 'react-slick';
// import { FaHeadset, FaStar, FaSyncAlt, FaTruck } from 'react-icons/fa';

// const CustomerSay = () => {
//   const sliderSettings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     arrows: false,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           dots: true,
//           vertical: true, 
//           verticalSwiping: true,
//         },
//       },
//     ],
//   };

//   const testimonials = [
//     {
//       id: 1,
//       icon: <FaSyncAlt size={32} />,
//       title: '14-Day Returns',
//       description: 'Risk-free shopping with easy returns.',
//     },
//     {
//       id: 2,
//       icon: <FaTruck size={32} />,
//       title: 'Free Shipping',
//       description: 'No extra costs, just the price you see.',
//     },
//     {
//       id: 3,
//       icon: <FaHeadset size={32} />,
//       title: '24/7 Support',
//       description: '24/7 support, always here just for you.',
//     },
//     {
//       id: 4,
//       icon: <FaStar size={32} />,
//       title: 'Member Discounts',
//       description: 'Special prices for our loyal customers.',
//     },
//   ];


// const customerReviews = [
//   {
//     id: 1,
//     image: "https://example.com/images/customers/customer1.jpg",
//     name: "Sybil Sharp",
//     review: "Vantara is amazing! The spices are fresh and aromatic, and the handcrafted items are exquisite. The staff were very knowledgeable about the products. Highly recommended!",
//     productImage: "https://example.com/images/products/cardamom.jpg",
//     productName: "Organic Wayanad Cardamom",
//     price: "$15.00",
//   },
//   {
//     id: 2,
//     image: "https://example.com/images/customers/customer2.jpg",
//     name: "Mark G.",
//     review: "I love shopping at Vantara! The organic teas and handwoven baskets are top quality. Every visit is a delightful experience, and the products always exceed my expectations.",
//     productImage: "https://example.com/images/products/tea.jpg",
//     productName: "Wayanad Special Tea Blend",
//     price: "$12.00",
//   },
//   {
//     id: 3,
//     image: "https://example.com/images/customers/customer3.jpg",
//     name: "Anita P.",
//     review: "The traditional jewelry and eco-friendly crafts at Vantara are stunning. Great for gifts and home décor. I’m always impressed by the authenticity and quality of their products.",
//     productImage: "https://example.com/images/products/jewelry.jpg",
//     productName: "Handcrafted Tribal Necklace",
//     price: "$25.00",
//   },
// ];

//   return (
//     <div className="container py-5">

//       <div className="text-center mb-4 mt-5">
//         <h2 className="fw-bold">Customer Say!</h2>
//         <p className="text-muted fs-5 mt-2">
//           Our customers adore our products, and we constantly aim to delight them.
//         </p>
//       </div>


//       <div className="d-block d-md-none">
//         <Slider {...{ ...sliderSettings, vertical: true }}>
//           {customerReviews.map((review) => (
//             <div key={review.id} className="bg-white text-black p-3 rounded-4 shadow-sm border border-secondary-subtle">
//               <img
//                 src={review.image}
//                 alt={review.name}
//                 className="w-100 rounded-top-4 h-60 object-fit-cover"
//                 style={{ height: '200px' }}
//               />
//               <div className="p-3">
//                 {/* Stars */}
//                 <div className="d-flex mb-2">
//                   {[...Array(5)].map((_, i) => (
//                     <span key={i} className="text-warning me-1">
//                       <i className="bi bi-star-fill"></i>
//                     </span>
//                   ))}
//                 </div>

//                 {/* Review Text */}
//                 <p className="mb-3 fst-italic text-dark">
//                   {review.review}
//                 </p>

  
//                 <div className="d-flex align-items-center mb-3">
//                   <strong>{review.name}</strong>
//                   <span className="ms-2">
//                     <i className="fas fa-circle-check text-success" style={{ fontSize: '0.8rem' }}></i>
//                   </span>
//                 </div>

               
//                 <hr className="my-3" />
//                 <div className="d-flex align-items-center">
//                   <img
//                     src={review.productImage}
//                     alt={review.productName}
//                     className="rounded-circle me-2"
//                     style={{ width: '40px', height: '40px' }}
//                   />
//                   <div>
//                     <p className="mb-0 fw-medium">{review.productName}</p>
//                     <p className="mb-0">{review.price}</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>

// {/* 
//       <div className="d-none d-md-flex overflow-auto pb-4" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
//         <style>
//           {`
//             .testimonial-scroll::-webkit-scrollbar {
//               display: none;
//             }
//             .testimonial-card {
//               min-width: 540px;
//               margin-right: 20px;
//             }
//             @media (max-width: 576px) {
//               .testimonial-card {
//                 width: 85%;
//                 min-width: 85%;
//               }
//             }
//           `}
//         </style>
//         {customerReviews.map((review) => (
//           <div key={review.id} className="testimonial-card">
//             <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100">
//               <div className="row g-0">
//                 <div className="col-4">
//                   <img
//                     src={review.image}
//                     alt={review.name}
//                     className="img-fluid h-100 object-fit-cover"
//                   />
//                 </div>
//                 <div className="col-8 p-4">
//                   <div className="d-flex mb-2">
//                     {[...Array(5)].map((_, i) => (
//                       <span key={i} className="text-warning me-1">
//                         <i className="bi bi-star-fill"></i>
//                       </span>
//                     ))}
//                   </div>

//                   <p className="mb-3 fst-italic">
//                     {review.review}
//                   </p>
//                   <div className="d-flex align-items-center mb-3">
//                     <strong>{review.name}</strong>
//                     <span className="ms-1">
//                       <i className="fas fa-circle-check text-success" style={{ fontSize: '0.8rem' }}></i>
//                     </span>
//                   </div>
//                   <hr className="my-3" />
//                   <div className="d-flex align-items-center">
//                     <img
//                       src={review.productImage}
//                       alt={review.productName}
//                       className="rounded-circle me-2"
//                       style={{ width: '40px', height: '40px' }}
//                     />
//                     <div>
//                       <p className="mb-0 fw-medium">{review.productName}</p>
//                       <p className="mb-0 text-dark">{review.price}</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div> */}

//       <div className="d-none d-md-flex overflow-auto pb-4 testimonial-scroll" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
//   <style>
//     {`
//       .testimonial-scroll::-webkit-scrollbar {
//         display: none;
//       }
//       .testimonial-card {
//         min-width: 540px;
//         margin-right: 20px;
//       }
//       @media (max-width: 576px) {
//         .testimonial-card {
//           width: 85%;
//           min-width: 85%;
//         }
//       }
//     `}
//   </style>

//   {customerReviews.map((review) => (
//     <div key={review.id} className="testimonial-card">
//       <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100">
//         <div className="p-4">
//           {/* Stars */}
//           <div className="d-flex mb-2">
//             {[...Array(5)].map((_, i) => (
//               <span key={i} className="text-warning me-1">
//                 <i className="bi bi-star-fill"></i>
//               </span>
//             ))}
//           </div>

//           {/* Review Text */}
//           <p className="mb-3 fst-italic">{review.review}</p>

//           {/* Customer Name */}
//           <div className="d-flex align-items-center mb-3">
//             <strong>{review.name}</strong>
//             <span className="ms-1">
//               <i className="fas fa-circle-check text-success" style={{ fontSize: '0.8rem' }}></i>
//             </span>
//           </div>

//           <hr className="my-3" />

//           {/* Product Info */}
//           <div className="d-flex align-items-center">
//             <img
//               src={review.productImage}
//               alt={review.productName}
//               className="rounded-circle me-2"
//               style={{ width: '40px', height: '40px' }}
//             />
//             <div>
//               <p className="mb-0 fw-medium">{review.productName}</p>
//               <p className="mb-0 text-dark">{review.price}</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   ))}
// </div>

//       <div className="row justify-content-center mt-4 d-none d-md-flex">
//         <div className="col-auto">
//           <nav>
//             <Slider {...sliderSettings}></Slider>
//           </nav>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CustomerSay;

import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Slider from 'react-slick';
import { FaHeadset, FaStar, FaSyncAlt, FaTruck } from 'react-icons/fa';

const CustomerSay = () => {
 const sliderSettingsMobile = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
  vertical: true,
  verticalSwiping: true,
  centerMode: false,      
  variableWidth: false,  
};
  const sliderSettingsDesktop = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2, 
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1, 
        },
      },
    ],
  };

  const customerReviews = [
    {
      id: 1,
      image: "https://thumb.ac-illust.com/51/51e1c1fc6f50743937e62fca9b942694_t.jpeg",
      name: "Sybil Sharp",
      review: "Vantara is amazing! The spices are fresh and aromatic, and the handcrafted items are exquisite. The staff were very knowledgeable about the products. Highly recommended!",
      productImage: "https://thumb.ac-illust.com/51/51e1c1fc6f50743937e62fca9b942694_t.jpeg",
      productName: "Organic Wayanad Cardamom",
      // price: "₹15.00",
    },
    {
      id: 2,
      image: "https://thumb.ac-illust.com/51/51e1c1fc6f50743937e62fca9b942694_t.jpeg",
      name: "Mark G.",
      review: "I love shopping at Vantara! The organic teas and handwoven baskets are top quality. Every visit is a delightful experience, and the products always exceed my expectations.",
      productImage: "https://thumb.ac-illust.com/51/51e1c1fc6f50743937e62fca9b942694_t.jpeg",
      productName: "Wayanad Special Tea Blend",
      // price: "₹12.00",
    },
    {
      id: 3,
      image: "https://thumb.ac-illust.com/51/51e1c1fc6f50743937e62fca9b942694_t.jpeg",
      name: "Anita P.",
      review: "The traditional jewelry and eco-friendly crafts at Vantara are stunning. Great for gifts and home décor. I’m always impressed by the authenticity and quality of their products.",
      productImage: "https://thumb.ac-illust.com/51/51e1c1fc6f50743937e62fca9b942694_t.jpeg",
      productName: "Handcrafted Tribal Necklace",
      // price: "₹25.00",
    },
  ];

  return (
    <div className="container py-5">
      <div className="text-center mb-4 mt-5">
        <h2 className="fw-bold">Customer Say!</h2>
        <p className="text-muted fs-5 mt-2">
          Our customers adore our products, and we constantly aim to delight them.
        </p>
      </div>

      {/* Mobile Slider */}
      <div className="d-block d-md-none">
      <Slider {...sliderSettingsMobile}>
  {customerReviews.map((review) => (
    <div
      key={review.id}
      style={{ width: "100%" }}
      className="bg-white border rounded-4 shadow-sm p-3"
    >
      {/* Stars */}
      <div className="d-flex mb-2">
        {[...Array(5)].map((_, i) => (
          <span key={i} className="text-warning me-1">
            <i className="bi bi-star-fill"></i>
          </span>
        ))}
      </div>

      {/* Review Text */}
      <p className="mb-3 fst-italic text-dark">{review.review}</p>

      {/* Customer Name */}
      <div className="d-flex align-items-center mb-3">
        <strong>{review.name}</strong>
        <span className="ms-2">
          <i
            className="fas fa-circle-check text-success"
            style={{ fontSize: "0.8rem" }}
          ></i>
        </span>
      </div>

      <hr className="my-3" />

      {/* Product Info */}
      <div className="d-flex align-items-center">
        {/* <img
          src={review.productImage}
          alt={review.productName}
          className="rounded-circle me-2"
          style={{ width: "40px", height: "40px" }}
        /> */}
        <div>
          <p className="mb-0 fw-medium">{review.productName}</p>
          {/* <p className="mb-0">{review.price}</p> */}
        </div>
      </div>
    </div>
  ))}
</Slider>

      </div>

      {/* Desktop Slider */}
      <div className="d-none d-md-block">
        <Slider {...sliderSettingsDesktop}>
          {customerReviews.map((review) => (
            <div key={review.id} className="p-2">
              <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100">
                <div className="p-4">
                  <div className="d-flex mb-2">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className="text-warning me-1">
                        <i className="bi bi-star-fill"></i>
                      </span>
                    ))}
                  </div>
                  <p className="mb-3 fst-italic">{review.review}</p>
                  <div className="d-flex align-items-center mb-3">
                    <strong>{review.name}</strong>
                    <span className="ms-1">
                  <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '0.8rem' }}></i>
                    </span>
                  </div>
                  <hr className="my-3" />
                  <div className="d-flex align-items-center">
                    {/* <img
                      src={review.productImage}
                      alt={review.productName}
                      className="rounded-circle me-2"
                      style={{ width: '40px', height: '40px' }}
                    /> */}
                    <div>
                      <p className="mb-0 fw-medium">{review.productName}</p>
                      <p className="mb-0 text-dark">{review.price}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default CustomerSay;
